// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal{
    position : fixed;
    top : 0;
    left : 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0, 0.7);
    z-index: 99;
}


.modal .container{
    position: fixed;
    top: 20%;
    left: 4%;
    right: 4%;
    width: 92%;
    padding: 1px 1px;
    background-color: black;
    box-shadow: 0 0 20px rgba(0,0,0, 0.8);
    border: 0.3em Ridge orangered;
    border-radius: 30px;
}

.container .close{
    background-color: white;
    border: 0;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 15px;
    width: 60%;
    height: 18%;
    padding: 2px 10px;
    font-size: 35px;
    color: black;
    border: 0.15em Ridge orangered;
    border-radius: 20px;
}

.container .close:active{
    background-color: orangered;
    color: white;
}

.close svg{
    margin-right: 10px;
    color: black;
}

.modal h2{
    margin-bottom: 4em;
    margin-top: 80px;
    font-size: 2em;
    text-align: center;
    font-weight: bold;
    text-shadow: 0.05em 0.05em 0.05em orangered;
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/modal.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,WAAW;AACf;;;AAGA;IACI,eAAe;IACf,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,qCAAqC;IACrC,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,2CAA2C;IAC3C,YAAY;AAChB","sourcesContent":[".modal{\r\n    position : fixed;\r\n    top : 0;\r\n    left : 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0,0,0, 0.7);\r\n    z-index: 99;\r\n}\r\n\r\n\r\n.modal .container{\r\n    position: fixed;\r\n    top: 20%;\r\n    left: 4%;\r\n    right: 4%;\r\n    width: 92%;\r\n    padding: 1px 1px;\r\n    background-color: black;\r\n    box-shadow: 0 0 20px rgba(0,0,0, 0.8);\r\n    border: 0.3em Ridge orangered;\r\n    border-radius: 30px;\r\n}\r\n\r\n.container .close{\r\n    background-color: white;\r\n    border: 0;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: absolute;\r\n    bottom: 15px;\r\n    width: 60%;\r\n    height: 18%;\r\n    padding: 2px 10px;\r\n    font-size: 35px;\r\n    color: black;\r\n    border: 0.15em Ridge orangered;\r\n    border-radius: 20px;\r\n}\r\n\r\n.container .close:active{\r\n    background-color: orangered;\r\n    color: white;\r\n}\r\n\r\n.close svg{\r\n    margin-right: 10px;\r\n    color: black;\r\n}\r\n\r\n.modal h2{\r\n    margin-bottom: 4em;\r\n    margin-top: 80px;\r\n    font-size: 2em;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    text-shadow: 0.05em 0.05em 0.05em orangered;\r\n    color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
